var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 19.4857V8.17143C0 7.77333 0.0931872 7.39619 0.279562 7.04C0.465937 6.68381 0.72275 6.39047 1.05 6.16L8.925 0.502857C9.38437 0.167619 9.90937 0 10.5 0C11.0906 0 11.6156 0.167619 12.075 0.502857L19.95 6.16C20.2781 6.39047 20.5354 6.68381 20.7217 7.04C20.9081 7.39619 21.0009 7.77333 21 8.17143V19.4857C21 20.1771 20.7427 20.7693 20.2282 21.2621C19.7137 21.7549 19.096 22.0008 18.375 22H14.4375C14.0656 22 13.7541 21.8793 13.503 21.6379C13.2519 21.3966 13.1259 21.0982 13.125 20.7429V14.4571C13.125 14.1009 12.999 13.8026 12.747 13.5621C12.495 13.3215 12.1835 13.2008 11.8125 13.2H9.1875C8.81562 13.2 8.50412 13.3207 8.253 13.5621C8.00187 13.8034 7.87587 14.1018 7.875 14.4571V20.7429C7.875 21.099 7.749 21.3978 7.497 21.6392C7.245 21.8806 6.9335 22.0008 6.5625 22H2.625C1.90312 22 1.28537 21.754 0.77175 21.2621C0.258125 20.7701 0.000875 20.178 0 19.4857Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.116c11b9f7116a808811b2cc5ab76455.svg";
export { ForwardRef as ReactComponent };